export default [

  {
    id: 0,
    img: 'https://http2.mlstatic.com/guitarra-gibson-traditional-les-paul-premium-plus-wine-red-D_NQ_NP_711687-MLB42319823910_062020-F.webp',
    name: 'Gibson Traditional Les Paul Premium Plus Wine Red',
    state: 'New',
    from: 'Juiz de Fora, Brazil',
    price: 450,
  },
  {
    id: 1,
    img: 'https://media.musiciansfriend.com/is/image/MMGS7/MU75BK-Concert-Ukulele-Black/H79198000001000-00-220x220.jpg',
    name: 'Mitchell MU75BK Concert Ukulele',
    state: 'New',
    from: 'London, UK',
    price: 129.99,
  },
  {
    id: 2,
    img: 'https://gloimg.gbtcdn.com/storage/item/6538088194642685952/15607/f6f43ac93373.jpg_100x100.jpg',
    name: 'Digital Piano vidaXL with 88-key Pedals Black Melamine Panel - Black France',
    state: 'Used',
    from: 'Wroclaw, Poland',
    price: 650,
  },
];
